<!--
  FloatBall
  在 各前端项目 中 一式N份
-->
<template>
  <div class="nav-left">
    <div ref="drag_icon" class="drag-icon" @touchstart.stop="handleTouchStart"
      @touchmove.prevent.stop="handleTouchMove($event)" @click="onClick_icon" :style="{
        left: left + 'px',
        top: top + 'px',
        width: itemWidth + 'px',
        height: itemHeight + 'px',
      }" v-if="isShow">
      {{ text }}
    </div>

    <!-- vue2 和 vue3 的 popup 有区别 所以封装统一一下 -->
    <BudoPopup v-model="popupShow">
      <div @click="dev_click_title" class="float-ball-title">导航</div>

      <div class="user-info">
        <van-image width="10vw" height="10vw" fit="cover" :src="userInfo_avatar" class="user-info-img"
          @click="go_mine" />
        <div>
          <span> {{ userInfo_wxUserid }} </span>
          <span> . </span>
          <span> {{ userInfo_nickName }} </span>
        </div>
      </div>

      <!-- 后台配置的菜单列表 -->
      <van-cell v-for="e in menuList" :key="e.permissionId" :title="e.name" @click="go_menu(e)" :icon="e.icon" />

      <div v-if="devMode">
        <div class="dev-tool-title">--- 开发者工具 ---</div>

        <van-button @click="dev_up_devMode">开发者模式开关 = {{ devMode }}</van-button>
        <van-button @click="dev_go_web">go web</van-button>
        <van-button @click="dev_go_movie">go movie</van-button>
        <van-button @click="dev_go_web_index_v3">go web/index-v3</van-button>
        <van-button @click="dev_go_movie_index">go movie/index</van-button>
        <van-button @click="dev_go_module_user_index">go_module_user_index</van-button>
        <van-button @click="dev_go_test_users">go_test_users</van-button>
        <van-button @click="go_v6_home">go_v6_home</van-button>
        <van-button @click="dev_go_login">go_login</van-button>
        <van-button @click="dev_logout">logout</van-button>
      </div>
    </BudoPopup>
  </div>
</template>

<script>
const _range_ = -25;

export default {
  props: {
    text: { default: "" },

    itemWidth: { default: 40 },

    itemHeight: { default: 40 },
  },

  data() {
    return {
      popupShow: false,
      left: 0,
      top: 0,
      startToMove: false,
      isShow: true,
      timer: null,
      currentTop: null,
      clientW: document.documentElement.clientWidth, //视口宽
      clientH: document.documentElement.clientHeight, //视口高

      devMode: false,
      timeoutId: null,
      clickCount: 0,

      menuList: [],

      userInfo_avatar: "",
      userInfo_wxUserid: "",
      userInfo_nickName: "",
    };
  },

  created() {
    this.left = 0 + _range_;
    this.top = this.clientH / 2 - this.itemHeight / 2;
  },

  mounted() {
    this.load_devMode();

    this.bindScrollEvent();

    this.read_userInfo_avatar();
    this.read_userInfo_nickName();
    this.read_userInfo_wxUserid();
  },

  beforeDestroy() {
    // 记得销毁一些全局的的事件
    this.removeScrollEvent();
  },

  methods: {
    go_mine() {
      location.href = "/web/user-center-index";
    },

    onClick_icon() {
      this.popupShow = true;

      // 用 fetch 大家都支持 不要 token
      if (window._api_popup_menu_list_) {
        fetch(window._api_popup_menu_list_)
          .then((res) => res.json())
          .then((json) => {
            this.menuList = json.data;
          });
      }
    },

    load_devMode() {
      this.devMode = localStorage.getItem("budo.devmode.v2");

      console.log("#73 devMode=", this.devMode);
      if (this.devMode) {
        this.devMode_true();
      }
    },

    read_userInfo_avatar() {
      var userInfo;
      var session = sessionStorage.getItem("rc-25-userInfo")
      if(session) {
        userInfo = JSON.parse(session).content;
      }

      this.userInfo_avatar = userInfo ? userInfo.avatar : "";
    },

    read_userInfo_wxUserid() {
      var userInfo;
      var session = sessionStorage.getItem("rc-25-userInfo")
      if(session) {
        userInfo = JSON.parse(session).content;
      }

      this.userInfo_wxUserid = userInfo ? userInfo.wxUserid : "0";
    },

    read_userInfo_nickName() {
      var userInfo;
      var session = sessionStorage.getItem("rc-25-userInfo")
      if(session) {
        userInfo = JSON.parse(session).content;
      }

      this.userInfo_nickName = userInfo ? userInfo.nickName : "用户";
    },

    dev_logout() {
      document.cookie.split(";").forEach(function (cookie) {
        var idx = cookie.indexOf("=");
        var name = idx > -1 ? cookie.substring(0, idx) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      });

      localStorage.clear();
      sessionStorage.clear();

      sessionStorage.setItem("budo.wx-auth-no-auto", "no-auto-float-ball");
      localStorage.setItem("budo.devmode.v2", "true");

      $budo_toast("after dev_logout");
    },

    dev_up_devMode() {
      if (this.devMode) {
        if (VConsole.instance) {
          VConsole.instance.destroy();
        }

        localStorage.removeItem("budo.devmode.v2");
        this.devMode = false;

        $budo_toast("关闭 开发者工具");
        return;
      }

      this.devMode_true();
      $budo_toast("打开 开发者工具");
    },

    devMode_true() {
      localStorage.setItem("budo.devmode.v2", "true");
      this.devMode = true;
      new VConsole();
    },

    dev_click_title() {
      this.clickCount++;

      clearTimeout(this.timeoutId);

      this.timeoutId = setTimeout(() => {
        this.clickCount = 0;
      }, 1000);

      console.log("#89 clickCount=", this.clickCount);

      if (this.clickCount > 5) {
        this.devMode_true();
      }
    },

    go_menu(menu) {
      location.href = menu.path;
    },

    dev_go_login() {
      var redirect_url = location.pathname + location.search + location.hash
      localStorage.setItem("budo.v2_redirect_url", redirect_url);
      location.href = "/v4/login";
    },

    dev_go_test_users() {
      location.href = "/web/go_test_users";
    },

    dev_go_web() {
      location.href = "/web/";
    },

    dev_go_movie() {
      location.href = "/movie/";
    },

    dev_go_web_index_v3() {
      location.href = "/web/index-v3";
    },

    dev_go_movie_index() {
      location.href = "/movie/index";
    },

    dev_go_module_user_index() {
      location.href = "/web/user-center-index";
    },

    go_v6_home() {
      location.href = "/v6/home";
    },

    handleTouchStart() {
      this.startToMove = true;
      this.$refs.drag_icon.style.transition = "none";
    },

    handleTouchMove(e) {
      const clientX = e.targetTouches[0].clientX; //手指相对视口的x
      const clientY = e.targetTouches[0].clientY; //手指相对视口的y
      const isInScreen =
        clientX <= this.clientW &&
        clientX >= 0 &&
        clientY <= this.clientH &&
        clientY >= 0;
      if (this.startToMove && e.targetTouches.length === 1) {
        if (isInScreen) {
          this.left = clientX - this.itemWidth / 2;
          this.top = clientY - this.itemHeight / 2;
        }
      }
    },

    handleIconY() {
      if (this.top < 0) {
        this.top = _range_; // 不上帖上边所以设置为 _range_ 没设置0
      } else if (this.top + this.itemHeight > this.clientH) {
        this.top = this.clientH - this.itemHeight - _range_; // 不让帖下边所以减 _range_
      }
    },

    bindScrollEvent() {
      window.addEventListener("scroll", this.handleScrollStart);
    },

    removeScrollEvent() {
      window.removeEventListener("scroll", this.handleScrollStart);
    },

    handleScrollStart() {
      this.isShow = false;
      this.timer && clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.handleScrollEnd();
      }, 300);
      this.currentTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    },

    handleScrollEnd() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      // 判断是否停止滚动的条件
      if (this.scrollTop == this.currentTop) {
        this.isShow = true;
      }
    },
  },
};
</script>

<style scoped>
.user-info {
  text-align: center;
  font-size: 14px;
}

.user-info-img {
  margin-bottom: 2vw;
  border-radius: 50%;
  overflow: hidden;
}

.dev-tool-title {
  font-size: 14px;
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.float-ball-title {
  background: #f1f1f1;
  text-align: center;
  height: 50px;
  line-height: 50px;
  margin-bottom: 15px;
  font-size: 16px;
}

.drag-icon {
  z-index: 9999;
  position: fixed;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #c3c3d62e;
  line-height: 40px;
  text-align: center;
  color: #fff;
  box-shadow: 5px 2px 10px #d7d8e0;
}

.v-enter {
  opacity: 1;
}

.v-leave-to {
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s;
}
</style>
